const $inject = [];

const lbaTextInput = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaTextInputCtrl',
    controllerAs: 'vm',
    template: require('./lbaTextInput.html')
  }
};

lbaTextInput.$inject = $inject;

export default lbaTextInput;



// WEBPACK FOOTER //
// ./src/components/lbaTextInput/lbaTextInputDir.js